// /app/frontend/src/components/frugal-v2/components/ListItem.jsx
// Generic list item component - i18n enabled (85 lines)

import React from 'react';
import { Check } from 'lucide-react';
import ItemMenu from './ItemMenu';

/**
 * Get underline color based on days until due
 * @returns {string} Tailwind border-bottom class
 */
const getUnderlineClass = (daysUntil, isPaid) => {
  if (isPaid) return '';
  if (daysUntil < 0) return 'border-b-2 border-red-500'; // Overdue - red
  if (daysUntil <= 3) return 'border-b-2 border-amber-500'; // Due soon - yellow
  return '';
};

/**
 * ListItem - Reusable list item for expenses, incomes, etc.
 * @param {function} t - i18n translation function (required)
 */
const ListItem = ({
  item,
  colorClass,
  onToggle,
  onEdit,
  onDelete,
  showStatus = false,
  showMenu = false,
  t
}) => {
  const isPaid = item.is_paid || item.status === 'paid';
  const underlineClass = showStatus ? getUnderlineClass(item.days_until, isPaid) : '';
  
  return (
    <div
      className={`flex items-center justify-between p-3 rounded-lg transition-all ${underlineClass} ${
        isPaid ? 'bg-white/5 opacity-75' : 'bg-white/5 hover:bg-white/10'
      }`}
    >
      {/* Left: Day + Name */}
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <span className={`text-xs font-medium w-8 ${isPaid ? 'text-slate-400' : colorClass}`}>
          {item.day}
        </span>
        <span className={`text-sm truncate ${
          isPaid 
            ? 'line-through text-slate-400 decoration-slate-500/70 decoration-[1.5px]' 
            : 'text-white'
        }`}>
          {item.name}
        </span>
      </div>

      {/* Right: Amount + Actions */}
      <div className="flex items-center gap-2">
        <span className={`text-sm font-medium ${
          isPaid ? 'text-slate-400 line-through decoration-slate-500' : colorClass
        }`}>
          ${item.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </span>

        {/* Toggle button */}
        <button
          onClick={() => onToggle(item.id)}
          className={`w-6 h-6 rounded flex items-center justify-center border transition-all ${
            isPaid
              ? 'bg-emerald-500 border-emerald-500 text-white'
              : 'border-white/30 hover:border-white/50'
          }`}
        >
          {isPaid && <Check className="w-4 h-4" />}
        </button>

        {/* Menu (optional) */}
        {showMenu && (
          <ItemMenu onEdit={() => onEdit(item)} onDelete={() => onDelete(item.id)} t={t} />
        )}
      </div>
    </div>
  );
};

export default ListItem;
